import {
  AdvisorLayerModeProvider,
  GlobalSearch,
  Navigation,
  NavigationContextProvider,
  OrganizationsSearch,
  RefinerInitializer,
  SideNavbar,
} from '@components'

import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import { QueryClientProvider } from 'react-query'

import { AccountsContextProvider } from '@modules-deprecated/app/accounts'
import {
  UserOrganizationContextProvider,
  UserOrganizationSettingsContextProvider,
} from '@modules-deprecated/app/organization'
import { UserOrganizationsContextProvider } from '@modules-deprecated/app/organizations'
import {
  IsTrustedPartnerContextProvider,
  UmbrellaContextProvider,
  UserUmbrellasContextProvider,
} from '@modules-deprecated/app/umbrellas'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import { SubscriptionPlansContextProvider } from '@views/settings/routes/OrganizationSubscriptionSettings/contexts/subscriptionPlansContext'

import { queryClient } from '../../config/queryClient'
import { EmberNavigate } from '../../contexts/emberRouterContext'
import { EmberUserTypeContextProvider } from '../../contexts/emberUserTypeContext'
import { GlobalSearchContextProvider } from '../../contexts/globalSearchContext'
import { IntercomContextProvider } from '../../contexts/intercomContext'
import { OrganizationsSearchContextProvider } from '../../contexts/organizationsSearchContext'
import { SideNavbarContextProvider } from '../../contexts/sideNavbarContext'
import { ThemeProvider } from '../../contexts/themeProvider'
import { HistoryRouter } from '../../utils/HistoryRouter'

const MODULE_NAME = 'menu-module'

class DashboardWebComponent extends DOMModel {
  @byAttrVal currentroutename: string
  @byAttrVal currentroutepath: string
  @byAttrVal organizationid: string
  @byAttrVal umbrellaid: string
  @byAttrVal userType: string
  @byAttrVal withsidenavbar: string
  @registerEvent('navigate') navigate: Function | undefined
}

interface MenuModuleProps {
  currentroutename: string
  currentroutepath: string
  onNavigate: EmberNavigate
  organizationid: string
  umbrellaid: string
  userType: string
  withsidenavbar: 'true' | 'false'
}

const MenuModule = ({
  currentroutename,
  currentroutepath,
  onNavigate,
  organizationid,
  umbrellaid,
  userType,
  withsidenavbar,
}: MenuModuleProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <HistoryRouter>
          <ModalContextProvider>
            <UmbrellaContextProvider umbrellaId={umbrellaid}>
              <CurrentUserContextProvider>
                <UserUmbrellasContextProvider>
                  <IsTrustedPartnerContextProvider organizationId={organizationid}>
                    <UserOrganizationsContextProvider>
                      <UserOrganizationContextProvider organizationId={organizationid}>
                        <UserOrganizationSettingsContextProvider organizationId={organizationid}>
                          <AccountsContextProvider organizationId={organizationid}>
                            <EmberUserTypeContextProvider userType={userType}>
                              <GlobalSearchContextProvider>
                                <RefinerInitializer>
                                  <IntercomContextProvider>
                                    <SideNavbarContextProvider withSideNavbar={withsidenavbar === 'true'}>
                                      {/* SubscriptionPlansContextProvider is needed here to ensure subscription plans prices are available on app load, do not remove */}
                                      <SubscriptionPlansContextProvider>
                                        <AdvisorLayerModeProvider>
                                          <SideNavbar />
                                          <NavigationContextProvider umbrellaId={umbrellaid}>
                                            <OrganizationsSearchContextProvider>
                                              <OrganizationsSearch />
                                              <Navigation />
                                            </OrganizationsSearchContextProvider>
                                          </NavigationContextProvider>
                                          <GlobalSearch />
                                        </AdvisorLayerModeProvider>
                                      </SubscriptionPlansContextProvider>
                                    </SideNavbarContextProvider>
                                  </IntercomContextProvider>
                                </RefinerInitializer>
                              </GlobalSearchContextProvider>
                            </EmberUserTypeContextProvider>
                          </AccountsContextProvider>
                        </UserOrganizationSettingsContextProvider>
                      </UserOrganizationContextProvider>
                    </UserOrganizationsContextProvider>
                  </IsTrustedPartnerContextProvider>
                </UserUmbrellasContextProvider>
              </CurrentUserContextProvider>
            </UmbrellaContextProvider>
          </ModalContextProvider>
        </HistoryRouter>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

const MenuElement = createCustomElement(MenuModule, DashboardWebComponent, 'element')

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, MenuElement)

export default MenuElement
